export default __webpack_public_path__ + "static/curry-dff231800443c70085d139687cfae44f.png";